import { useEffect, useState } from 'react'
import Button from '../common/Button'
import LogoMark from '../common/Logo'
import ThemeToggle from '../common/ThemeToggle'

const navLinks = [
  { label: 'درباره من', href: '#about' },
  { label: 'نمونه‌کارها', href: '#portfolio' },
  { label: 'دوره‌ها', href: '#courses' },
  { label: 'تماس', href: '#consultation' },
]

// هدر ثابت: روی هیرو شفاف، بعد از اسکرول شیشه‌ای می‌شود + نوار پیشرفت اسکرول
const Header = () => {
  const [scrolled, setScrolled] = useState(false)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    let raf = 0
    const update = () => {
      const y = window.scrollY
      setScrolled(y > 40)
      const max = document.documentElement.scrollHeight - window.innerHeight
      setProgress(max > 0 ? Math.min(1, y / max) : 0)
    }
    const onScroll = () => {
      cancelAnimationFrame(raf)
      raf = requestAnimationFrame(update)
    }
    update()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', onScroll)
      cancelAnimationFrame(raf)
    }
  }, [])

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#faf7f2]/85 dark:bg-[#17120f]/80 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="container-custom">
        <div
          className={`flex items-center justify-between transition-all duration-300 ${
            scrolled ? 'h-16' : 'h-24'
          }`}
        >
          {/* لوگو — نشانِ مستقل، بدون قاب اضافه */}
          <a href="#home" className="flex items-center gap-3 shrink-0">
            <LogoMark className="h-10 w-10 shrink-0 shadow-lg" />
            <div className="flex flex-col leading-none">
              <span
                className={`text-lg font-bold tracking-tight transition-colors duration-300 ${
                  scrolled ? 'text-gray-900 dark:text-gray-100' : 'text-white'
                }`}
              >
                الونا
              </span>
              <span
                className={`text-[11px] tracking-wide mt-1 transition-colors duration-300 ${
                  scrolled ? 'text-gray-500 dark:text-gray-400' : 'text-white/70'
                }`}
              >
                کلاس آموزش ناخن
              </span>
            </div>
          </a>

          {/* ناوبری وسط */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors duration-300 ${
                  scrolled
                    ? 'text-gray-600 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-300'
                    : 'text-white/85 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* اکشن‌ها */}
          <div className="flex items-center gap-2">
            <ThemeToggle
              className={
                scrolled
                  ? 'text-gray-500 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/5'
                  : 'text-white hover:bg-white/10'
              }
            />
            <Button
              variant={scrolled ? 'primary' : 'luxury'}
              size="sm"
              href="#consultation"
            >
              رزرو
            </Button>
          </div>
        </div>
      </div>

      {/* نوار پیشرفت اسکرول */}
      <div
        className={`absolute inset-x-0 bottom-0 h-[2px] transition-opacity duration-300 ${
          scrolled ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div
          className="h-full bg-primary-500 origin-right"
          style={{ transform: `scaleX(${progress})` }}
        />
      </div>
    </header>
  )
}

export default Header
